import { useMutation, useQueryClient } from "@tanstack/react-query";

import { notificationsKeys } from "@/hooks/queryKeys";
import { useUser } from "@/hooks/useUser";
import apiClient from "@/lib/api/client";

import { showToast, ToastTypeEnum } from "../settings/utils/showToast";

export function useSlackIntegration(code: string | undefined) {
  const { data } = useUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (code: string) =>
      apiClient.url(`/notifications/preferences/slack`).patch({ code }).json(),
    mutationKey: notificationsKeys.updateSlack(code),
    onError: () => {
      showToast(`Error in Slack Integration`, ToastTypeEnum.ERROR);
    },
    onSuccess: async () => {
      showToast(`Slack successfully integrated.`, ToastTypeEnum.SUCCESS);

      if (!data?.user?.email) {
        return;
      }

      await queryClient.invalidateQueries({
        queryKey: notificationsKeys.user(data?.user.email),
      });
    },
  });
}
